import type { LessonDetailsResponse } from "@/features/workspaces/types/lessonDetails";

import { axiosApiInstance } from "@/libs/axios";

/**
 * Fetch lesson details for a tutor
 */
export const fetchTutorLessonDetails = async (workspaceId: string, lessonId: string) => {
  const response = await axiosApiInstance.get(
    `/workspaces/${workspaceId}/lessons/tutor/${lessonId}`,
  );

  return response.data as LessonDetailsResponse;
};

/**
 * Fetch lesson details for a student
 */
export const fetchStudentLessonDetails = async (workspaceId: string, lessonId: string) => {
  const response = await axiosApiInstance.get(
    `/workspaces/${workspaceId}/lessons/student/${lessonId}`,
  );

  return response.data as LessonDetailsResponse;
};

/**
 * Cancel a lesson
 */
export const cancelLesson = async (workspaceId: string, lessonId: string) => {
  await axiosApiInstance.post(`/workspaces/${workspaceId}/lessons/${lessonId}/cancel`);
};

/**
 * Fetch lesson listings for a tutor
 */
export const fetchTutorLessonListings = async (
  workspaceId: string,
  dateFrom: string,
  dateTo: string,
  subject?: string,
  status?: string,
  search?: string,
  page = 1,
) => {
  const params: Record<string, string> = {
    date_from: dateFrom,
    date_to: dateTo,
    page: page.toString(),
  };

  if (subject) params.subject = subject;
  if (status) params.status = status;
  if (search) params.keyword = search;

  const { data } = await axiosApiInstance.get(`workspaces/${workspaceId}/lessons/tutor/listing`, {
    params,
  });

  return data;
};

/**
 * Fetch lesson listings for a student
 */
export const fetchStudentLessonListings = async (
  workspaceId: string,
  dateFrom: string,
  dateTo: string,
  status?: string,
  search?: string,
  page = 1,
) => {
  const params: Record<string, string> = {
    date_from: dateFrom,
    date_to: dateTo,
    page: page.toString(),
  };

  if (status) params.status_id = status;
  if (search) params.keyword = search;

  const { data } = await axiosApiInstance.get(`workspaces/${workspaceId}/lessons/student/listing`, {
    params,
  });

  return data;
};
